import ClubSalesListItem from '../dto/ClubSalesListItem';
import Error from '../model/Error';
import axios from 'axios';

export default class ClubSalesListItemRepository {
    static findByClubId(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/sales-list/items`)
                .then((response) => resolve(response.data.data.map((data) => ClubSalesListItem.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static createInvoice(memberId, clubFees) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/members/${memberId}/sales-list/invoicing`, clubFees)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
